import React from 'react';
// eslint-disable-next-line import/no-extraneous-dependencies
import SortArrow from './SortArrow';

function SortableHeader({
  sortable,
  classes,
  sortKey,
  activeSortKey,
  label,
  shortLabel,
  direction,
  setDirection,
  setSortKey,
  Component = React.Fragment,
}) {
  const onClick = () => {
    if (sortable) {
      if (activeSortKey === sortKey) {
        setDirection(direction === 'asc' ? 'desc' : 'asc');
      } else {
        setSortKey(sortKey);
      }
    }
  };

  const headerClasses = `stats-table__sortable-header ${classes}`;

  return (
    <Component>
      <div
        role="button"
        tabIndex={0}
        aria-hidden="true"
        className={headerClasses}
        onClick={onClick}
      >
        <div
          className={
            sortKey === activeSortKey ? 'text-color-primary-yellow' : ''
          }
        >
          <span className="label">{label}</span>
          <span className="short-label">{shortLabel || label}</span>
        </div>
        {sortable && sortKey === activeSortKey && (
          <SortArrow direction={direction} />
        )}
      </div>
    </Component>
  );
}

export default SortableHeader;
